import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { InputSelector } from "../../components/Forms/InputSelector";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { useNavigate, useParams } from "react-router";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel } from "../../atoms";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import BaseForm from "../../components/Forms/BaseForm";
import { useSearchParams } from "react-router-dom";
import { useSetChangesMade } from "../../components/Publishing/utils";

const BaseCreateItem = (): JSX.Element => {
  const params = useParams();
  const [originFrom, originId] = useOriginParams();

  const modelData = useAtomValue(modelDataAtom);
  const modelName = params.model?.toString() || "";
  useValidateModel(modelName);
  const setChangesMade = useSetChangesMade(modelName);

  const capitalizedName = checkTitle(modelName);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoading) {
      const [emptyData, getSchema, relationships] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );

      const dataWithParams = getSchema.reduce((obj, item) => {
        const key = item.name;
        const checkValue = searchParams.get(key);
        if (searchParams.get(key))
          return {
            ...obj,
            [key]: checkValue,
          };
        return obj;
      }, {});

      const originValues =
        originFrom && originId
          ? {
              [`owner_${originFrom}_id`]: parseInt(originId || "-1"),
            }
          : {};

      setItemData({ ...emptyData, ...dataWithParams, ...originValues });
      setSchema(getSchema);
      setIsLoading(false);
    }
  }, [modelData]);

  const saveItem = async () => {
    try {
      const getCurrent = await apiAgent.DataType.getAll(modelName);

      const response = await apiAgent.DataType.create(modelName, {
        item_rows: [
          {
            ...itemData,
            sort_id: getCurrent?.data?.length || 1,
          },
        ],
      });

      if (response.status === 200) {
        console.log("response from create endpoint", response.data);
        tMsg.success(`${capitalizedName} successfully created`);
        setChangesMade();
        console.log(response.data);
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}`);
        else if (response?.data?.ids[0])
          navigate(`/m/${modelName}/show/${response.data.ids[0]}`);
        else navigate(`/m/${modelName}`);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error creating ${capitalizedName}`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: checkTitle(modelName),
      link: `/m/${modelName}`,
    },
  ];

  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Create ${capitalizedName}`}>
          <BackButton />
        </TitleBar>
        <BaseForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem();
          }}
        />
      </PageContent>
      <PageFooterBar>
        <SaveButton />
      </PageFooterBar>
    </PageContainer>
  );
};

export default BaseCreateItem;
